module.exports = __webpack_public_path__ + "img/DA.7a978280.png";